// frontend/src/components/ProtectedRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext'; // Путь к вашему AppContext

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAppContext();
  const location = useLocation();

  if (isLoading) {
    // Можно показать компонент загрузки, пока проверяется статус аутентификации
    return <div>Loading authentication status...</div>;
  }

  if (!isAuthenticated) {
    // Пользователь не авторизован, перенаправляем на /login
    // Сохраняем текущий путь в location.state, чтобы LoginPage мог его использовать для редиректа обратно
    // или передаем через query параметр `next`
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  return children; // Пользователь авторизован, отображаем запрошенный компонент
};

export default ProtectedRoute;